// extracted by mini-css-extract-plugin
export default {"gallery":"JFiZY4nQksSnF5iAOzni"};